<template>
  <div>
    <div class="vx-col w-full">
      <div class="dropdown-with-label">
        <small class="date-label"
          >{{ $t("setup.label.SalesChannel") }}<span class="required"> *</span>
        </small>
        <v-select
          label="code_value"
          v-model="conditionObj.salesChannel"
          :options="salesChannelOptions"
          :reduce="(obj) => obj.code_value"
          :placeholder="$t('placeholder.label.SelectOne')"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="min-w-200 w-full mb-2 bg-white"
        >
          <template v-slot:option="option">{{ option.code_value }}</template>
        </v-select>
      </div>
    </div>
    <div class="vx-col w-full">
      <div class="dropdown-with-label">
        <small class="date-label"
          >{{ $t("setup.label.PaymentType") }}<span class="required"> *</span>
        </small>
        <v-select
          label="code_value"
          v-model="conditionObj.paymentType"
          :options="salesMotionOptions"
          :reduce="(obj) => obj.code_value"
          :placeholder="$t('placeholder.label.SelectOne')"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="min-w-200 w-full mb-2 bg-white"
        >
          <template v-slot:option="option">{{ option.code_value }}</template>
        </v-select>
      </div>
    </div>
    <div class="vx-col w-full">
      <div class="dropdown-with-label">
        <small class="date-label"
          >{{ $t("setup.label.OrderType") }}<span class="required"> *</span>
        </small>
        <v-select
          label="code_value"
          v-model="conditionObj.orderType"
          :options="orderTypeOptions"
          :reduce="(obj) => obj.code_value"
          :placeholder="$t('placeholder.label.SelectOne')"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="min-w-200 w-full mb-2 bg-white"
        >
          <template v-slot:option="option">{{ option.code_value }}</template>
        </v-select>
      </div>
    </div>
    <div class="vx-col w-full">
      <div class="dropdown-with-label">
        <small class="date-label"
          >{{ $t("setup.label.BusinessType") }}<span class="required"> *</span>
        </small>
        <v-select
          label="code_value"
          v-model="conditionObj.businessType"
          :options="businessTypeOptions"
          :reduce="(obj) => obj.code_value"
          :placeholder="$t('placeholder.label.SelectOne')"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="min-w-200 w-full mb-2 bg-white"
        >
          <template v-slot:option="option">{{ option.code_value }}</template>
        </v-select>
      </div>
    </div>
    <div class="vx-row center my-4">
      <div class="vx-col w-full">
        <vs-button
          color="primary"
          class="footerButton-next mb-5"
          @click="onSubmit"
          >{{ $t("setup.label.Submit") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    discountTriggerId: {
      type: [String, Number],
      default: "",
    },
    triggerCondtionData: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: String,
      default: "Add",
    },
    name: {
      type: String,
      default: "Discount",
    },
  },
  emits: ["onCreateSuceess", "onEditSuccess"],
  data() {
    return {
      conditionObj: {
        businessType: "All",
        salesChannel: "All",
        paymentType: "All",
        orderType: "All",
      },
      salesChannelOptions: [
        { code_value: "All" },
        { code_value: "POS" },
        { code_value: "Online" },
      ],
      salesMotionOptions: [
        { code_value: "All" },
        { code_value: "Credit Card" },
        { code_value: "Debit Card" },
        { code_value: "UPI" },
      ],
      orderTypeOptions: [
        { code_value: "ALL" },
        { code_value: "ACTIVATION" },
        // { code_value: "DISCONNECTION" },
        // { code_value: "TERMINATION" },
        // { code_value: "SUSPENTATION" },
        { code_value: "REACTIVATION" },
        { code_value: "RENEWAL BEFORE AUTOEXIPIRY" },
        { code_value: "RENEWAL AFTER EXIPIRY" },
        { code_value: "CHANGE_PLAN" },
      ],
      businessTypeOptions: [
        { code_value: "All" },
        { code_value: "Residential" },
        { code_value: "Business" },
        { code_value: "Government" },
        { code_value: "Tourist" },
        { code_value: "Student" },
      ],
    };
  },
  computed: {
    ...mapState({
      triggerEntityList: (state) => state.discount.triggerEntityList,
      triggerValueOptions: (state) => state.discount.triggerValueOptions,
    }),
  },
  watch: {
    triggerCondtionData: {
      handler: function (val) {
        if (val && this.mode === "Edit") {
          this.editDataRender();
        }
      },
      deep: true,
    },
  },

  methods: {
    async getValueOptionsByTemplate(templatename) {
      await this.$store.dispatch(
        "discount/fetchTriggerValueOptions",
        templatename
      );
    },
    onSubmit() {
      if (this.mode === "Add") {
        this.addTriggerCondition();
      } else {
        this.updateTriggerCondition();
      }
    },
    async addTriggerCondition() {
      try {
        let body = {
          discountTriggerId: this.discountTriggerId,
          conditionJson: JSON.stringify(this.ruleConfigs),
          conditionMysql: "",
          ...this.conditionObj,
        };

        await this.$store.dispatch("discount/createDiscountTriggerCondition", {
          ...body,
        });
        this.$emit("onCreateSuceess");
        this.$swal({
          title: "Success",
          icon: "success",
          text: `${this.name} Trigger Condition Added Successfully!`,
          type: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Success",
          icon: "error",
          text: "Something went wrong",
        });
      }
    },
    async updateTriggerCondition() {
      try {
        const triggerConditionPayloadData = {
          discountTriggerId: this.discountTriggerId,
          conditionJson: JSON.stringify(this.ruleConfigs),
          conditionMysql: "",
          ...this.conditionObj,
        };
        await this.$store.dispatch("discount/updateDiscountTriggerCondition", {
          id: this.triggerCondtionData.id,
          data: triggerConditionPayloadData,
        });
        this.$emit("onEditSuccess");
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Edit Discount Trigger Condition Successfully!",
          type: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Success",
          icon: "error",
          text: "Something went wrong",
        });
      }
    },
    editDataRender() {
      const {
        businessType = "",
        salesChannel = "",
        paymentType = "",
        orderType = "",
      } = this.triggerCondtionData;
      this.conditionObj = {
        businessType,
        salesChannel,
        paymentType,
        orderType,
      };
    },
    resetFields() {
      this.conditionObj.businessType = "All";
      this.conditionObj.salesChannel = "All";
      this.conditionObj.paymentType = "All";
      this.conditionObj.orderType = "All";
    },
  },
  mounted() {},
};
</script>

<style scoped>
.align-btn {
  margin-top: 1rem;
}
.nested-bg {
  background-color: #cee0ec;
}
</style>
